import { WorkspaceDeveloperRequestBodyState as e } from "@maat/api-main/types";
//#region src/workspaceDeveloper/buildCurlCommand.ts
var t = (e) => `'${e.replace(/'/g, "'\\''")}'`, n = (e) => {
	if (!e) return "";
	let t = new URLSearchParams();
	for (let [n, r] of Object.entries(e)) for (let e of Array.isArray(r) ? r : [r]) e != null && t.append(n, String(e));
	let n = t.toString();
	return n ? `?${n}` : "";
}, r = (r, i) => {
	let a = r.method.toUpperCase(), o = [`curl${a === "GET" ? "" : ` -X ${a}`} ${t(`${i}${r.path}${n(r.query)}`)}`, "-H \"Authorization: Bearer $MAAT_ACCESS_TOKEN\""];
	if (r.request_body_state === e.Stored) {
		let e = typeof r.request_body == "string" ? r.request_body : JSON.stringify(r.request_body);
		o.push(`-H ${t(`Content-Type: ${r.request_content_type ?? "application/json"}`)}`), o.push(`--data ${t(e)}`);
	}
	return o.join(" \\\n  ");
};
//#endregion
export { r as buildCurlCommand };
